import React, { useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Dialog } from '@reach/dialog';
import UpArrowSVG from '../../components/UpArrowSVG';
import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import InteriorsImageGrid from '../../components/InteriorsImageGrid';
import '@reach/dialog/styles.css';
import CloseSVG from '../../components/CloseSVG';

const Interiors = () => {

    const [showDialog, setShowDialog] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    const open = imageData => {
        setSelectedImage(imageData);
        setShowDialog(true);
    };

    const close = () => setShowDialog(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <Layout>
            <SEO
                title="Interiors"
                description="Our interiors are made with durability and style. With real hardwood flooring and stunning staircases, your home will certainly make your home a sight to behold."
            />
            <section className="main-interiors" aria-label="Interior Photos">
                <div className="main-interiors__container">
                    <h2 className="main-interiors__title">
                        Interiors
                    </h2>
                    <InteriorsImageGrid open={open} />
                    <button onClick={scrollToTop} className="main-interiors__scroll">
                        <UpArrowSVG className="main-interiors__svg" />
                        <span className="visually-hidden">Scroll To Top</span>
                    </button>
                </div>
            </section>
            <Dialog isOpen={showDialog} onDismiss={close}>
                <button className="dialog-close" onClick={close}>
                    <CloseSVG className="dialog-svg" />
                </button>
                <GatsbyImage image={selectedImage} className="dialog-image" alt="" />
            </Dialog>
        </Layout>
    );
};

export default Interiors;
